import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Platform, StyleSheet } from 'react-native';

import { IconLink, theme, useResponsive } from '@sg/garnish';

export const LeftIcon = ({ onPress }: Readonly<{ onPress: () => void }>) => {
  const { formatMessage } = useIntl();
  const { match } = useResponsive();

  return (
    <IconLink
      testID="location.search-bar.back-button"
      name="IconArrowLeft"
      style={Platform.OS === 'web' ? match([styles.iconXS, styles.icon]) : undefined}
      accessibilityLabel={formatMessage(messages.leftIconBack)}
      accessibilityHint={formatMessage(messages.homeNavigation)}
      onPress={onPress}
    />
  );
};

const styles = StyleSheet.create({
  icon: {
    marginRight: theme.spacing['4'],
  },
  iconXS: {
    marginLeft: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  leftIconBack: {
    defaultMessage: 'Back',
    description: 'Left Icon | Back',
  },
  homeNavigation: {
    defaultMessage: 'open home page',
    description: 'Home | Navigation',
  },
});
